const MobileExploreTheWorld = ({ onClick }: any) => {
  return (
    <div className='mx-[14px] flex flex-col items-center overflow-hidden rounded-[24px] bg-white pt-[48px] lg_hidden'>
      <p className='mx-[14px] mb-[4px] text-center text-[24px] font-[700] leading-[28px] text-title'>
        Explore the avian world with loved ones!
      </p>
      <p className='mx-auto mb-[12px] w-[60%] text-center text-sm leading-[20px] text-[#3E3E3E]'>
        No limits on the number of people who can access these abilities.
      </p>
      <div className='relative'>
        <img
          className='w-full'
          src='/images/mobile-explore-world.webp'
        />
        <div className='absolute bottom-[16px] left-[40px] right-[40px] leading-[44px] text-white '>
          <div
            onClick={onClick}
            className='block w-full rounded-[12px] bg-[#EE6C4D] text-center font-[700]'
          >
            Order Now!
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileExploreTheWorld;
